import React from "react"
import { Link } from "react-router-dom"
import type { DashboardQuickLink } from "../types"
import "./DashboardQuickLink.style.scss"

interface DashboardQuickLinkProps {
  link: DashboardQuickLink
}

const DashboardQuickLinkCard = ({ link }: DashboardQuickLinkProps) => {
  const Icon = link.icon

  return (
    <Link
      to={link.path}
      className={`dashboard-quick-link is-${link.tone}`}
    >
      <div className="dashboard-quick-link__icon" aria-hidden>
        <Icon size={20} />
      </div>
      <span>{link.label}</span>
    </Link>
  )
}

export default DashboardQuickLinkCard
